<template>
  <div id="app">
    <div id="nav">
      <div class="logo">
        <img
          src="/logo.png"
          alt="Logo"
        >
      </div>
      <el-menu
        :default-active="this.$route.path"
        class="el-menu-demo"
        mode="horizontal"
        router
        @select="handleSelect"
      >
        <el-menu-item v-for="(item, i) in navList" :key="i" :index="item.name">
          <template slot="title">
            <span> {{ item.navItem }}</span>
          </template>
        </el-menu-item>
        <el-menu-item
          index="logout"
          @click="$logout"
        >
          Cerrar sesión
        </el-menu-item>
      </el-menu>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
    data() {
      return {
        navList : [
          {
            name: "/",
            navItem: "Tickets"
          },
          {
            name: "/deliverymen",
            navItem: "Repartidores"
          },
          {
            name: "/map",
            navItem: "Mapa"
          },
          {
            name: "/asofarma",
            navItem: "Asofarma"
          }
        ],
      };
    },
    methods: {
      handleSelect(key, keyPath) {
       this.activeIndex = key;
      }
    }
  }

</script>
<style>

 @font-face {
    font-family: 'trebuc';
    src: url("/fonts/Trebuchet/trebuc.ttf") format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'amaranth';
    src: url("/fonts/Amaranth/amaranth-regular-webfont.woff2") format('woff2');
    font-weight: normal;
    font-style: normal;
  }

html body {
  padding: 0;
  margin: 0;
}

#app {
  font-family: trebuc, amaranth, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  background-color: #fff;
  height: 60px;
  padding: 0;
  margin: 0;
  display: flex;
  /* align-items:center; 
  justify-content: left; */
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.logo {
  flex: .1;
  margin: 0 0 0 5%;
}

img{
  object-fit: cover;
  width: 200px;
}

</style>
